
document.addEventListener("DOMContentLoaded", function() {
    let products = document.querySelectorAll('.grid-product');
    let count = document.querySelector('.product-count');
    count.innerHTML = products.length


    getSearchParams()

});


let selectedType = []
  let selectedCollections = []
  let selectedSize = []
  let selectedCase = []
  let selectedStrap = []
  let selectedDial = []

  const noResultsInfo = document.getElementById('no-results')


  const toggleList = (button) => {
        if(button.nextElementSibling) {
            button.nextElementSibling.classList.toggle('hidden')
        }
    }

    const showFilter = () => {
        filter = document.querySelector('.sjoo-product-grid-filter')

        filter.classList.add('show')
    }

    const closeFilter = () => {
        filter = document.querySelector('.sjoo-product-grid-filter')

        filter.classList.remove('show')
    }



  const filteredProducts = () => {
    let products = document.querySelectorAll('.grid-product');
    let count = document.querySelector('.product-count');

    products.forEach(product => {
        product.classList.add('hidden')

        let collections = product.dataset.collections.split(' ');
        let options = product.dataset.options.split(' ');
        let type = product.dataset.type.split(' ');

        let foundInType = false
        let foundInCollection = false
        let foundInCase = false
        let foundInStrap = false
        let foundInDial = false

        if(selectedType.length > 0) {
            selectedType.forEach(sc => {
                let typeExistsInProduct = type.includes(sc.toString())
                if(typeExistsInProduct) {
                    foundInType = true
                }
            })
        } else {
            foundInType = true
        }


        if(selectedCollections.length > 0) {
            selectedCollections.forEach(sc => {
                let collectionExistsInProduct = collections.includes(sc.toString())
                if(collectionExistsInProduct) {
                    foundInCollection = true
                }
            })
        } else {
            foundInCollection = true
        }

        if(selectedCase.length > 0) {
            selectedCase?.forEach(sc => {
                let optionExistsInProduct = options.includes(sc.toString())
                if(optionExistsInProduct) {
                    foundInCase = true
                }
            })
        } else {
            foundInCase = true
        }

        if(selectedStrap.length > 0) {
            selectedStrap?.forEach(sc => {
                let optionExistsInProduct = options.includes(sc.toString())
                if(optionExistsInProduct) {
                    foundInStrap = true
                }
            })
        } else {
            foundInStrap = true
        }

        if(selectedDial.length > 0) {
            selectedDial?.forEach(sc => {
                let optionExistsInProduct = options.includes(sc.toString())
                if(optionExistsInProduct) {
                    foundInDial = true
                }
            })
        } else {
            foundInDial = true
        }

        if(foundInCollection && foundInCase && foundInStrap && foundInDial && foundInType) {
            product.classList.remove('hidden')
        }
    });

    count.innerHTML = products.length - document.querySelectorAll('.grid-product.hidden').length;
    let resetFilterButton = document.getElementById('reset-filter-button')
    if( products.length == document.querySelectorAll('.grid-product.hidden').length) {
        noResultsInfo.classList.remove('hidden')
    } else {
        noResultsInfo.classList.add('hidden')
    }
    if(document.querySelectorAll('.grid-product.hidden').length == 0) {
        resetFilterButton.classList.add('opacity-40')
        resetFilterButton.classList.add('pointer-events-none')
    } else {
        resetFilterButton.classList.remove('opacity-40')
        resetFilterButton.classList.remove('pointer-events-none')
    }

    updateUrlParams()
  }


  const selectOption = (value, type, button) => {
    if(type === 'size') {
        const index = selectedSize.indexOf(value);
        if (index === -1) {
            // If the value does not exist, add it to the array
            selectedSize.push(value);
            button.classList.remove('opacity-40');
        } else {
            // If the value exists, remove it from the array
            selectedSize.splice(index, 1);
            button.classList.add('opacity-40');
        }
    }

    if(type === 'case') {
        const index = selectedCase.indexOf(value);
        if (index === -1) {
            // If the value does not exist, add it to the array
            selectedCase.push(value);
            button.classList.remove('opacity-40');
        } else {
            // If the value exists, remove it from the array
            selectedCase.splice(index, 1);
            button.classList.add('opacity-40');
        }
    }

    if(type === 'strap') {
        const index = selectedStrap.indexOf(value);
        if (index === -1) {
            // If the value does not exist, add it to the array
            selectedStrap.push(value);
            button.classList.remove('opacity-40');
        } else {
            // If the value exists, remove it from the array
            selectedStrap.splice(index, 1);
            button.classList.add('opacity-40');
        }
    }

    if(type === 'dial') {
        const index = selectedDial.indexOf(value);
        if (index === -1) {
            // If the value does not exist, add it to the array
            selectedDial.push(value);
            button.classList.remove('opacity-40');
        } else {
            // If the value exists, remove it from the array
            selectedDial.splice(index, 1);
            button.classList.add('opacity-40');
        }
    }
    filteredProducts()
  }


  const selectType = (value, button) => {
    const index = selectedType.indexOf(value);
    if (index === -1) {
        // If the value does not exist, add it to the array
        selectedType.push(value);
        button.classList.remove('opacity-40');
    } else {
        // If the value exists, remove it from the array
        selectedType.splice(index, 1);
        button.classList.add('opacity-40');
    }
    filteredProducts()
  }

  const selectCollections = (value, button) => {
    const index = selectedCollections.indexOf(value);
    if (index === -1) {
        // If the value does not exist, add it to the array
        selectedCollections.push(value);
        button.classList.remove('opacity-40');
    } else {
        // If the value exists, remove it from the array
        selectedCollections.splice(index, 1);
        button.classList.add('opacity-40');
    }
    filteredProducts()
}


const resetFilter = () => {
    selectedType = []
    selectedCollections = []
    selectedSize = []
    selectedCase = []
    selectedStrap = []
    selectedDial = []

    let buttons = document.querySelectorAll('.sjoo-product-grid-filter button.filter-action')

    buttons.forEach( b => {
        b.classList.add('opacity-40')
    })
    filteredProducts()
}


const updateUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);

   // Remove existing filter parameters
   urlParams.delete('collections');
   urlParams.delete('case');
   urlParams.delete('strap');
   urlParams.delete('dial');

   // Add updated filter parameters
   if (selectedCollections.length > 0) {
       urlParams.append('collections', selectedCollections);
   }
   if (selectedCase.length > 0) {
       urlParams.append('case', selectedCase);
   }
   if (selectedStrap.length > 0) {
       urlParams.append('strap', selectedStrap);
   }
   if (selectedDial.length > 0) {
       urlParams.append('dial', selectedDial);
   }

    // Update URL
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({}, '', newUrl);
}

const getSearchParams = () => {

    let url = new URL(window.location)
    let params = new URLSearchParams(url.search);

    if(params.getAll("collections")) {
        selectedCollections = params.getAll("collections")
        filteredProducts()
    }

    if(params.getAll("case")) {
        selectedCase = params.getAll("case")
        filteredProducts()
    }

    if(params.getAll("strap")) {
        selectedStrap = params.getAll("strap")
        filteredProducts()
    }

    if(params.getAll("dial")) {
        selectedDial = params.getAll("dial")
        filteredProducts()
    }


}